/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./LayoutRankingJianSheZhe.vue?vue&type=template&id=1839c605&scoped=true"
import script from "./LayoutRankingJianSheZhe.vue?vue&type=script&lang=js"
export * from "./LayoutRankingJianSheZhe.vue?vue&type=script&lang=js"
import style0 from "./LayoutRankingJianSheZhe.vue?vue&type=style&index=0&id=1839c605&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1839c605",
  null
  
)

export default component.exports